
function header_space(){
  var scrollPos = $(window).scrollTop();
  if (scrollPos > 0) {
    $(".announcement_bottom").hide();
  } else {
    if($('.announcement-timer').length == 0){
      $(".announcement_bottom").show();
    }
  }
  var headerHeight = $('[data-header-wrapper]').outerHeight();
  $('#PageContainer').css('padding-top', headerHeight + 'px');
  // lets the homepage hero fill exactly the screen below the header (no strip of the next section)
  document.documentElement.style.setProperty('--lumos-header-h', headerHeight + 'px');
}
document.addEventListener('DOMContentLoaded', header_space);
function card_line_height(){
  if($('.bottom_cart_drwr').length > 0){
    var height_cart_footer = 'calc(100% - '+ $('.bottom_cart_drwr').outerHeight() +'px)';
    $('.items_wrpr_drawer').css('height',height_cart_footer);  
  }
  // if($('#CartContainer .cart.ajaxcart').length > 0){
  //   var height_cart_footer = 'calc(100% - '+ ($('.cart-shipping__wrapper').outerHeight() + $('.drawer__subtitle').outerHeight() + 7) +'px)';
  //   $('#CartContainer .cart.ajaxcart').css('height',height_cart_footer);
  // }
}

  var checkCount = 0;
  var maxCount = 100;


  function checkKlaviyoButton() {
    // only product pages have the sticky add to cart bar
    if (!document.querySelector('.sticky_atc')) return;
    checkCount++;

    if (document.querySelector('#klaviyo-bis-button-container') != null && document.querySelector('#klaviyo-bis-button-container button') != null) {
      document.querySelector('.sticky_atc').textContent = document.querySelector('#klaviyo-bis-button-container button').textContent;
      document.querySelector('.sticky_atc').classList.add('klaviyo_trigger');
      document.querySelector('.product-single__form .addtocart').style.display = 'none';
    } else {
      document.querySelector('.sticky_atc').textContent = "ADD TO CART";
      document.querySelector('.sticky_atc').classList.remove('klaviyo_trigger');
      document.querySelector('.product-single__form .addtocart').style.display = 'block';
    }
    if (checkCount < maxCount) {
      setTimeout(checkKlaviyoButton, 100);
    }
  }

$(document).ready(function(){
  
  header_space();
  
  function select_second(){
    if($('.radio-wrapper.product-form__item input[type="radio"][value="2 Lights"]').length > 0){
      $('.radio-wrapper.product-form__item input[type="radio"][value="2 Lights"]').trigger('click'); 
    }else{
      setTimeout(function(){
        select_second();
      },1000);
    }
  }
  select_second();

  // function select_first(){
  //   if($('.radio-wrapper.product-form__item input[type="radio"][value="1 Light"]').length > 0){
  //     $('.radio-wrapper.product-form__item input[type="radio"][value="1 Light"]').trigger('click'); 
  //   }else{
  //     setTimeout(function(){
  //       select_first();
  //     },1000);
  //   }
  // }
  // select_first();
  
  function replace_word(vv,rd){
    console.log(rd);
    console.log('rdrdrd');
    $(vv).find('.junip-product-summary-review-count').html(rd + ' Reviews');
  }
  function find_review(){
    $('.product-single__meta .junip-product-summary').each(function(ii,vv){
      if($(vv).find('.junip-product-summary-review-count').length > 0){
        console.log($(vv).find('.junip-product-summary-review-count'));
        var review_data = $('.junip-product-summary-review-count').html();
        console.log(review_data)
        review_data = review_data.replace('(','');
        review_data = review_data.replace(')','');
        review_data = review_data.trim();
        setTimeout(function(){
          replace_word(vv,review_data);
        },1000);
      }else{
        setTimeout(function(){
          find_review();
        },1000);
      }
    });
  }
  find_review();

  $("[data-product-gallery]").on( 'change.flickity', function( event, index ) {
    if ( event.namespace == 'flickity' ) {
      var play_video = false;
      var video_pdp = $('[data-product-gallery] .product-single__media-flex-wrapper video');
      if($('[data-product-gallery] .product-single__media-flex-wrapper.is-selected').next().find('video').length > 0 || $('[data-product-gallery] .product-single__media-flex-wrapper.is-selected video').length  > 0){
        play_video = true;
      }
      if(play_video){
        $(video_pdp).trigger('play');
      }else{
        $(video_pdp).trigger('pause');
        $(video_pdp).currentTime = 0;
      }
    }
  });
  $('body').on('click','.product-single__meta .junip-product-summary-clickable',function(){
    console.log('review clicked');
    if($(".junip-product-review-rendered").length > 0){
      $('html, body').animate({
        scrollTop: $(".junip-product-review-rendered").offset().top - $('[data-header-wrapper]').outerHeight()
      }, 1000);  
    }
  });
  $('body').on('click','.guaranteed_popup',function(e){
    e.preventDefault();
    $('html').addClass('show_guaranteed_popup');
  });
  $('body').on('click','.close_guarantee, .guarantee_ovrly',function(e){
    e.preventDefault();
    $('html').removeClass('show_guaranteed_popup');
  });
  $('body').on('click','[data-login-toggle]',function(e){
    e.preventDefault();
    $('#CustomerLoginForm').hide();
    $('#RecoverPasswordForm').show();
  });

  $('body').on('click','.sticky_cart .sticky_atc',function(e){
    e.preventDefault();
    if($(this).hasClass('klaviyo_trigger')) {
      $('#klaviyo-bis-button-container button').trigger('click');
    } else {
      $('form[action="/cart/add"] [name="add"]').trigger('click');
    }
  });

  setInterval(function () {
    card_line_height();
  }, 1000);

  function setgroupgallery(cur_color,med_id){
    $productGallery.flickity( 'remove', $('.product-single__media-group-wrapper .product-single__media-flex-wrapper.thishas_alt_txt') );
    $thumbnailProductGallery.flickity('remove',$('.product-single__thumbnails .grid__item.thishas_alt_txt'));
    if(mediagroupColor[cur_color] != null && mediagroupColor[cur_color] != ''){
      for(var i=0;i < mediagroupColor[cur_color].length; i++){
        var imgsplit = mediagroupColor[cur_color][i].split('!===');
        var mediainner = '<div class="product-single__media" style="padding-top: 100.0%;"><img class="mfp-image product-template-'+imgsplit[1]+'" alt="'+cur_color+'" src="'+imgsplit[0]+'"></div>';
        if(imgsplit[2]){
          mediainner = '<div class="product-single__media product-single__media--video Im_in_video_one" style="padding-top: '+(imgsplit[3] || 100)+'%;"><video class="media-video product-template-'+imgsplit[1]+'" width="100%" muted loop controls playsinline preload="metadata" poster="'+imgsplit[0]+'"><source src="'+imgsplit[2]+'" type="video/mp4">Your browser does not support HTML5 video.</video></div>';
        }
        var htmlmain = $('<div class="product-single__media-flex-wrapper thishas_alt_txt"><div class="product-single__media-flex"><div class="product-single__media-wrapper">'+mediainner+'</div></div></div>');
        var htmlthumb = $('<li class="grid__item product-template-'+imgsplit[1]+' medium--one-third large--one-quarter product-single__media-wrapper thishas_alt_txt"><img src="'+imgsplit[0]+'"data-alt="'+cur_color+'"></li>');
        $productGallery.flickity( 'prepend', htmlmain );
        $thumbnailProductGallery.flickity('prepend',htmlthumb);
        if($thumbnailProductGallery.outerHeight() < 10){
          setTimeout(function(){
            $thumbnailProductGallery.flickity('resize');
          },500);
        }
      }
      var groupindex = $('.product-single__media-flex-wrapper .'+med_id).parents('.product-single__media-flex-wrapper').index();
      $productGallery.flickity( 'selectCell', groupindex, false, true );
      console.log('!!!!=',groupindex);
    }
  }

  $('body').on('change','.product_custom_swatch .product_custom_swatch_comb input',function(e){
    var med_id = $(this).attr('data-media-id');
    var med_badge = $(this).attr('data-badge-img');
    var med_src = $(this).attr('data-media-src');
    var cur_color = $(this).val();
    // var current_variant_id = $(this).attr('data-variant-id');
    $('.product_custom_swatch_comb .rangname:not([data-available="false"])').hide();
    $(this).parent().parent().find('.rangname').show();
    if(med_badge != '' && med_badge != undefined ){
      $('.new_badge_by_metafield').html('<img src="'+med_badge+'">');
    }else{
      $('.new_badge_by_metafield img').remove();
    }
    if($('.setGroupGalleryImage').length > 0){
      setgroupgallery(cur_color,med_id);
    }else{
      // const kachingBundles = document.querySelector('kaching-bundles-block');
      // kachingBundles.currentVariantId = current_variant_id;
      var index = $('.selected_cus_variant_image_thumb').index();
      $('.selected_cus_variant_image img').show().attr('srcset',med_src);
      $('.selected_cus_variant_image_thumb img').show().attr('src',med_src);
      $productGallery.flickity( 'selectCell', index, false, true );
    }
     if (document.querySelector('kaching-bundles-block') != null) {
      var kachingBundles = document.querySelector('kaching-bundles-block');
      kachingBundles.currentVariantId = parseInt($(this).attr("data-variant-id"));
    }
    var url = new URL(window.location.href);
    if (url.searchParams.has('variant')) {
      url.searchParams.set('variant', parseInt($(this).attr("data-variant-id")));
    } else {
      url.searchParams.append('variant', parseInt($(this).attr("data-variant-id")));
    }
    history.replaceState(null, '', url.toString());

    if($(this).attr('data-variant-availability') == 'true' || $(this).attr('data-variant-availability') == true) {
      
      $('.product-single__form .addtocart').html(`<b>ADD TO CART</b>`);
      $('.product-single__form .addtocart').removeAttr("disabled");
    } else {
      $('.product-single__form .addtocart').html(`SOLD OUT`);
      $('.product-single__form .addtocart').attr("disabled","disabled");
    }

    checkCount = 0;
    maxCount = 100;
   checkKlaviyoButton();   


  });
  if($('.product_custom_swatch').length > 0){
    $('.product_custom_swatch .product_custom_swatch_comb input:checked').trigger('change');
  }
  $('body').on('click','.custom_mobile_menu a[href="#quiz"]',function(e){
    // Let the browser set the #quiz hash so the quiz app can open; just close the drawer.
    if (window.location.hash === '#quiz') {
      // Hash already set (quiz was opened before): reset it so the app sees a change.
      e.preventDefault();
      history.replaceState(null, '', window.location.pathname + window.location.search);
      setTimeout(function () { window.location.hash = '#quiz'; }, 50);
    }
    $('.custom_mobile_menu .Drawer__Close').trigger('click');
  });
});


$(window).on('load scroll resize',function() {
  header_space();
  card_line_height();
  checkKlaviyoButton();
});


document.addEventListener("DOMContentLoaded", function () {
  const reelVideoList = document.querySelector(".reel_video_list");
  const leftArrow = document.querySelector(".left-arrow");
  const rightArrow = document.querySelector(".right-arrow");

  if(reelVideoList != null && reelVideoList != undefined){
    function updateArrows() {
      const scrollLeft = reelVideoList.scrollLeft;
      const scrollWidth = reelVideoList.scrollWidth;
      const clientWidth = reelVideoList.clientWidth;
  
      if (scrollLeft <= 0) {
        leftArrow.disabled = true;
        leftArrow.style.opacity = "0.3";
        leftArrow.style.cursor = "not-allowed";
      } else {
        leftArrow.disabled = false;
        leftArrow.style.opacity = "1";
        leftArrow.style.cursor = "pointer";
      }
  
      if (scrollLeft + clientWidth >= scrollWidth) {
        rightArrow.disabled = true;
        rightArrow.style.opacity = "0.3";
        rightArrow.style.cursor = "not-allowed";
      } else {
        rightArrow.disabled = false;
        rightArrow.style.opacity = "1";
        rightArrow.style.cursor = "pointer";
      }
    }
    leftArrow.addEventListener("click", () => {
      reelVideoList.scrollBy({ left: -100, behavior: "smooth" });
    });
  
    rightArrow.addEventListener("click", () => {
      reelVideoList.scrollBy({ left: 100, behavior: "smooth" });
    });
  
    reelVideoList.addEventListener("scroll", updateArrows);
  
    updateArrows();
  }
});




let countdownTimer = class extends HTMLElement {
  constructor() {
    super();
    console.log(this);
    const countdownElement = this.querySelector('.countdown__datetime');
    const counttime = countdownElement.dataset.timer;
    // const countDownDate = new Date(counttime).getTime() + (10 * 60 * 60 * 1000);

    const inputDate = new Date(counttime);
    const hawaiiOffset = 8 * 60; 
    const countDownDate = inputDate.getTime() - (hawaiiOffset * 60 * 1000); 
    
    const expired_msg = countdownElement.dataset.expired_msg;

    const days = this.querySelector('[data-days]');
    const hours = this.querySelector('[data-hours]');
    const minutes = this.querySelector('[data-minutes]');
    const seconds = this.querySelector('[data-seconds]');
    const countdown = this.querySelector(".countdown__timer");

    const updateTimer = () => {
      const nowTime = new Date();
      // const nowTime = new Date().toLocaleString("en-US", { timeZone: "Pacific/Honolulu" });
      const now = new Date().getTime() - (hawaiiOffset * 60 *1000);

      const distance = countDownDate - now;

      if (distance < 0) {
        clearInterval(timerInterval);
        if(document.querySelector('.announcement_bottom') != null) {
          document.querySelector('.announcement_bottom').style.display = 'block';
        }
        this.querySelector('.countdown__timer').style.display = 'none';
        if(document.querySelector('.announcement-timer') != null) {
          document.querySelector('.announcement-timer').style.display = 'none';
        }
        if(document.querySelector('.product_timer') != null) {
         document.querySelector('.product_timer').style.display = 'none';
        }
        return;
      }

      const d = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
      const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
      const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
      const s = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');

      days.innerHTML = d;
      hours.innerHTML = h;
      if(minutes != null){
        minutes.innerHTML = m;
      }
      if(seconds != null){
        seconds.innerHTML = s;
      }
    };

    const timerInterval = setInterval(updateTimer, 1000);
    updateTimer();
  }
};

customElements.get("countdown-timer") || customElements.define("countdown-timer", countdownTimer);

// The header countdown bar stays visible (sticky with the header), it is no longer hidden next to the product timer.

//  $('.js-qty__adjust').on('click', function(e) {
//   e.preventDefault();
//         var $el = $(this),
//             $qtySelector = $el.siblings('.js-qty__num'),
//             qty = parseInt($qtySelector.val().replace(/\D/g, ''));

//         qty = validateQty(qty);

//         // Add or subtract from the current quantity
//         if ($el.hasClass('js-qty__adjust--plus')) {
//           qty += 1;
//         } else {
//           qty -= 1;
//           if (qty <= 1) qty = 1;
//         }

//         // Update the input's number
//         $qtySelector.val(qty);
//          $el.closest(".cart__row").find('.js-qty__num').val(qty);
//         $('.btn--secondary.update-cart').trigger('click');  
//       });


(function () {
  var wrapper = document.querySelector('.header-wrapper');
  var bar = wrapper && wrapper.querySelector('.announcement-bar');
  if (!bar) return;
  var ticking = false;
  wrapper.style.transition = 'none';
  function update() {
    ticking = false;
    var offset = Math.min(Math.max(window.scrollY, 0), bar.offsetHeight);
    wrapper.style.transform = offset > 0 ? 'translateY(' + -offset + 'px)' : '';
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
// Cart count inside the bag icon: keep it in sync after any ajax cart request.
(function () {
  function paint(count) {
    count = parseInt(count, 10) || 0;
    var text = count > 99 ? '99+' : String(count);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? text : '';
      el.classList.toggle('is-empty', count < 1);
      el.classList.toggle('is-wide', text.length > 1);
    });
  }
  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paint(cart.item_count); })
      .catch(function () {});
  }
  function isCartUrl(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = origFetch.apply(this, arguments);
      if (isCartUrl(url)) { p.then(function () { setTimeout(refresh, 50); }, function () {}); }
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartUrl(url)) {
      this.addEventListener('loadend', function () { setTimeout(refresh, 50); });
    }
    return origOpen.apply(this, arguments);
  };
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();

// Sticky add to cart (mobile product page):
// - shown on load and while the main add to cart button is below the screen
// - hidden once the main button is reached, and stays hidden after scrolling past it
//   (it shows again when scrolling back up until the main button is below the screen)
// - hidden while a drawer is open
(function () {
  var sticky = document.querySelector('.sticky_cart');
  if (!sticky) return;

  var mainBtn = document.querySelector('.product-single__form .addtocart');
  var mainInView = false;

  function drawerOpen() {
    return document.documentElement.classList.contains('js-drawer-open') ||
           document.body.classList.contains('js-drawer-open');
  }

  var desktop = window.matchMedia('(min-width: 769px)');

  function place() {
    if (desktop.matches && mainBtn) {
      var r = mainBtn.getBoundingClientRect();
      sticky.style.left = r.left + 'px';
      sticky.style.width = r.width + 'px';
    } else {
      sticky.style.left = '';
      sticky.style.width = '';
    }
  }

  function apply() {
    place();
    var mainReached = mainBtn && mainBtn.getBoundingClientRect().top < 0;
    var mainShowing = desktop.matches && mainBtn && mainBtn.getBoundingClientRect().top < window.innerHeight;
    sticky.classList.toggle('sticky_cart--hidden', mainInView || mainShowing || mainReached || drawerOpen());
  }

  if (mainBtn && 'IntersectionObserver' in window) {
    // "In view" = the whole button is on screen (a half-cut button still needs the sticky one)
    new IntersectionObserver(function (entries) {
      mainInView = entries[0].intersectionRatio >= 0.99;
      apply();
    }, { threshold: [0, 0.99, 1] }).observe(mainBtn);
  }

  window.addEventListener('scroll', apply, { passive: true });
  window.addEventListener('resize', apply);

  var drawerObserver = new MutationObserver(apply);
  drawerObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  drawerObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  apply();
})();
// Mobile menu open: also lock the html element so the page behind the menu does not scroll
(function () {
  var root = document.documentElement;
  function sync() {
    root.classList.toggle('lumos-menu-open', document.body.classList.contains('active_mobile_menu'));
  }
  new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  sync();
})();
